import React from "react";
import { useLocation } from "react-router-dom";

export const CheckboxList = ({
    subFeaturesList,
    featuresBlock,
    index,
    handleSubblockChange,
    errors,
}) => {
    const subFeatures = subFeaturesList[index] || [];
    const location = useLocation();
    const { listId = "" } = location.state || {};

    return (
        <div className="flex-wrap gap-3 md:col-span-12 d-flex">
            <ul className="fl-wrap filter-tags no-list-style ds-tg" style={{ paddingTop: "10px" }}>
                {subFeatures.map((item) => {
                    const featureId = featuresBlock[index]?.feature_id;
                    const isChecked = featuresBlock?.[index]?.sub_features?.some(
                        sub_fea => sub_fea.toString() === item?.id.toString()
                    );

                    // Only include defaultChecked attribute if listId exists
                    const inputProps = {
                        type: "checkbox",
                        id: item?.id,
                        "data-feature-id": featureId,
                        onChange: (e) => handleSubblockChange(e, index)
                    };

                    if (listId) {
                        inputProps.defaultChecked = isChecked;
                    }

                    return (
                        <li key={item?.id} className="p-3 border border-gray-100">
                            <input {...inputProps} />
                            <label htmlFor={item?.id} style={{ padding: "0px 20px 0px 6px", top: 0 }}>
                                {item?.sub_heading}
                            </label>
                        </li>
                    );
                })}
            </ul>
            {errors?.features?.[index]?.sub_features && (
                <p className="text-red-500">{errors?.features?.[index]?.sub_features?.message}</p>
            )}
        </div>
    );
};